module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/pickup-4-a4e63916997ac8d4f519953cadd11e37.png";